import React, { useRef, useState } from 'react';
import AvatarEditor from 'react-avatar-editor';
import { putObject } from '@/utils/upload';

import { Avatar, Modal, message } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { dataURLtoBlob } from '@/utils/utils';

const MyAvatarEditor = (props) => {
  const { getAvatar, defaultImg } = props;
  const [file, setFile] = useState();
  const [avatar, setAvatar] = useState(defaultImg);
  const [editor, setEditor] = useState(null);
  const inputRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const setEditorRef = (edit) => {
    if (!edit) {
      return;
    }
    setEditor(edit);
  };
  const previewImg = () => {
    const img = editor.getImageScaledToCanvas().toDataURL();
    const blob = dataURLtoBlob(img);
    putObject({
      filename: file.name,
      file: blob,
      callback: (err, data) => {
        if (err) {
          message.error(err);
        }
        if (data) {
          setAvatar(`https://${data.Location}`);
          getAvatar(`https://${data.Location}`);
          setVisible(false);
        }
      },
    });
    setAvatar(img);
  };

  const fileChange = (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    // console.log(e.target.files)
    setFile(e.target.files[0]);
    setVisible(true);
  };
  const onCancel = () => {
    setVisible(false);
  };
  const onOk = () => {
    // 获取图片的url
    previewImg();
  };
  return (
    <>
      <Avatar
        size={64}
        icon={<UserOutlined />}
        src={avatar || defaultImg}
        onClick={() => {
          inputRef.current.click();
        }}
      />
      <input
        type="file"
        ref={inputRef}
        id="avatar-edit"
        style={{ display: 'none' }}
        onChange={fileChange}
        accept="image/*"
      />
      <Modal visible={visible} onCancel={onCancel} onOk={onOk} width={260}>
        <AvatarEditor
          image={file}
          ref={setEditorRef}
          width={200}
          height={200}
          borderRadius={100}
          border={0}
          color={[0, 0, 0, 0.4]}
          scale={1}
          rotate={0}
        />
      </Modal>
    </>
  );
};

export default MyAvatarEditor;
